/**
 * Great-circle distance, in miles.
 *
 * Lives here rather than in a host's utils folder because it is the only piece
 * of Explore's "Near me" filter that is neither a UI choice nor a device
 * capability: the radius buckets a drawer offers are presentation, resolving
 * where the dealer is standing is a port, and this is arithmetic.
 *
 * `Infinity` for a missing endpoint rather than a throw, and that is a contract
 * rather than laziness — an un-placeable listing PASSES the radius filter
 * instead of being hidden, so an unknown location must be a number the caller
 * can compare, not an exception it has to catch.
 */
const EARTH_RADIUS_MILES = 3958.8;

const toRadians = (degrees) => (degrees * Math.PI) / 180;

export const haversineMiles = (a, b) => {
    if (!a || !b) {
        return Infinity;
    }
    const deltaLatitude = toRadians(b.lat - a.lat);
    const deltaLongitude = toRadians(b.lng - a.lng);
    const latitudeA = toRadians(a.lat);
    const latitudeB = toRadians(b.lat);
    const h =
        Math.sin(deltaLatitude / 2) ** 2 +
        Math.cos(latitudeA) * Math.cos(latitudeB) * Math.sin(deltaLongitude / 2) ** 2;
    return 2 * EARTH_RADIUS_MILES * Math.asin(Math.min(1, Math.sqrt(h)));
};

export default haversineMiles;
